import { Module } from "vuex";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { state } from "./state";
import { RootState } from "@/store/modules/general/types";
import { actions } from './actions';

const namespaced = true;

type GeneralModule = Module<any, RootState>;

export const general: GeneralModule = {
  namespaced,
  mutations,
  getters,
  state,
  actions
};
